const fields = [{
    name: 'preconditionTemperature',
    className: 'preconditionTemperature',
    componentName: 'InputSingleline',
    suffix: '°C',
}]

export default fields
